import { useRowsChildrenInvalidate } from "PFApp/booking/store";
import { useActivityInvalidate } from "PFCore/hooks/queries/activity";
import { useBookingApprovalsInvalidate } from "PFCore/hooks/queries/bookings/approvals/use_booking_approvals_invalidate";
import { useProfileInvalidate } from "PFCore/hooks/queries/profile";
import { useCallback } from "react";

import { usePotentialWarningsQueryInvalidate } from "../components/booking_form/use_potential_warnings/use_potential_warnings_query_invalidate";

type ProfilesAvailabilitiesUpdatedEvent = {
  profile_ids: number[];
};

type UseProfilesAvailabilitiesUpdatedHandlerReturn = {
  handleBookingModuleProfilesAvailabilitiesUpdated: (e: ProfilesAvailabilitiesUpdatedEvent) => void;
  handleBookingModuleProfilesAvailabilitiesUpdatedForActivityWarnings: () => void;
};

export const useProfilesAvailabilitiesUpdatedHandler = (): UseProfilesAvailabilitiesUpdatedHandlerReturn => {
  const { invalidateProfile, invalidateBookingsDataByProfileId } = useProfileInvalidate();
  const { invalidateByProfileIds: invalidateRowChildrenByProfileIds } = useRowsChildrenInvalidate();
  const { invalidate: invalidateBookingApprovals } = useBookingApprovalsInvalidate();
  const { invalidateAll: invalidatePotentialWarnings } = usePotentialWarningsQueryInvalidate();
  const { invalidateAllActivityWarnings } = useActivityInvalidate();

  const handleBookingModuleProfilesAvailabilitiesUpdated = useCallback(
    async ({ profile_ids: profileIds }) => {
      await Promise.all(
        profileIds.map(async (profileId) => {
          await invalidateBookingsDataByProfileId(profileId);
          await invalidateProfile(profileId);
        })
      );
      await invalidateRowChildrenByProfileIds(profileIds);
      await invalidateBookingApprovals();
      await invalidatePotentialWarnings();
    },
    []
  );

  const handleBookingModuleProfilesAvailabilitiesUpdatedForActivityWarnings = useCallback(async () => {
    await invalidateAllActivityWarnings();
  }, []);

  return {
    handleBookingModuleProfilesAvailabilitiesUpdated,
    handleBookingModuleProfilesAvailabilitiesUpdatedForActivityWarnings
  };
};
